/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTuitionRateTierResponse
 */
export interface GetTuitionRateTierResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTuitionRateTierResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTuitionRateTierResponse
     */
    tuitionRatePlanId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetTuitionRateTierResponse
     */
    minQuantity: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetTuitionRateTierResponse
     */
    maxQuantity: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {number}
     * @memberof GetTuitionRateTierResponse
     */
    amount: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTuitionRateTierResponse
     */
    sortOrder: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the GetTuitionRateTierResponse interface.
 */
export function instanceOfGetTuitionRateTierResponse(value: object): value is GetTuitionRateTierResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tuitionRatePlanId' in value) || value['tuitionRatePlanId'] === undefined) return false;
    if (!('minQuantity' in value) || value['minQuantity'] === undefined) return false;
    if (!('maxQuantity' in value) || value['maxQuantity'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function GetTuitionRateTierResponseFromJSON(json: any): GetTuitionRateTierResponse {
    return GetTuitionRateTierResponseFromJSONTyped(json, false);
}

export function GetTuitionRateTierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTuitionRateTierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'tuitionRatePlanId': ApiUserTasksGetPageParameterFromJSON(json['tuitionRatePlanId']),
        'minQuantity': BalanceUnitStatementEntryDebitFromJSON(json['minQuantity']),
        'maxQuantity': BalanceUnitStatementEntryDebitFromJSON(json['maxQuantity']),
        'amount': json['amount'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
    };
}

export function GetTuitionRateTierResponseToJSON(json: any): GetTuitionRateTierResponse {
    return GetTuitionRateTierResponseToJSONTyped(json, false);
}

export function GetTuitionRateTierResponseToJSONTyped(value?: GetTuitionRateTierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'tuitionRatePlanId': ApiUserTasksGetPageParameterToJSON(value['tuitionRatePlanId']),
        'minQuantity': BalanceUnitStatementEntryDebitToJSON(value['minQuantity']),
        'maxQuantity': BalanceUnitStatementEntryDebitToJSON(value['maxQuantity']),
        'amount': value['amount'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
    };
}

